import React from 'react';
import { MoonIcon } from 'lucide-react';
import { images } from '../data/content';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Hero() {
  return <header className="bg-cream px-4 pb-12 pt-6 sm:pt-10" data-id="element-118" data-mp="9k0fha3kwjqp">
      <div className="mx-auto max-w-4xl text-center" data-id="element-119" data-mp="9igvp9iprqk6">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-120" data-mp="4n1lqsntuet1">
          <span className="flex items-center gap-2" data-id="element-121" data-mp="12a0l5b5wm0um">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-plum" data-id="element-122" data-mp="127eereur1rdz">
              <MoonIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-123" data-mp="xb5rfe6eervq" />
            </span>
            <span className="font-serif text-lg font-bold text-plum-dark" data-id="element-124" data-mp="s9qa9x7cd5im">The Peaceful Night Method™</span>
          </span>
          <span className="rounded-full border border-lavender-deep bg-white px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum" data-id="element-125" data-mp="nekmesudpgrw">
            The 7-Night Routine
          </span>
        </div>

        <h1 className="mt-6 font-serif text-[32px] font-extrabold leading-[1.12] text-ink sm:text-5xl md:text-[56px]" data-id="element-126" data-mp="384s3cj4feb0f">
          Create a 15-minute evening ritual to slow down and build a nighttime routine you can{' '}
          <em className="text-plum" data-id="element-127" data-mp="39al7s8moke0i">actually stick to</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-128" data-mp="39cpcgsselh1u">
          A simple step-by-step system designed to guide you through 7 nights so you can turn the final minutes of your day into a calming ritual. Includes <strong className="text-ink" data-id="element-129" data-mp="358zoa4fn51hc">6 premium volumes</strong>, <strong className="text-ink" data-id="element-130" data-mp="35akmq552t4kh">5 exclusive bonuses</strong> and <strong className="text-ink" data-id="element-131" data-mp="2ql692kugw0za">30+ rituals, checklists & planners</strong>.
        </p>

        <img src={images.stack} alt="The Peaceful Night Method™ — 6 volumes, 5 bonuses, digital guides and ritual cards" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-132" data-mp="2vjpywwc6lwwx" />

        <div className="mt-6" data-id="element-133" data-mp="2ljgzzaqt1xdu">
          <CtaButton id="hero-cta" label="I want the Peaceful Night Method" sublabel="Instant access · One-time payment of $27 USD · Lifetime access · 7-Day Guarantee" data-id="element-134" data-mp="2lmv3wnf4aene" />
          <Countdown data-id="element-135" data-mp="ic88ngd628yd" />
          <p className="mt-2 text-xs text-muted" data-id="element-136" data-mp="ibgm0v1jrlk8">Currency conversion is automatically handled according to your country.</p>
        </div>
      </div>
    </header>;
}